interface VersionUpdateMessageProps {
  onRefresh?: () => void;
}

export function VersionUpdateMessage(props: VersionUpdateMessageProps) {
  const handleRefresh = () => {
    if (props.onRefresh) {
      props.onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <div class="fixed inset-0 z-50 flex min-h-screen items-center justify-center bg-baseTertiaryLight p-4 px-6 py-8 sm:p-4">
      <div class="shadow-xl w-full max-w-sm rounded-2xl bg-baseLight sm:max-w-md">
        <div class="p-6 text-center sm:p-8">
          {/* Icon */}
          <div class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-basePrimaryLight to-basePrimaryDark sm:h-20 sm:w-20">
            <svg
              class="h-8 w-8 text-baseLight sm:h-10 sm:w-10"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </div>

          {/* Title */}
          <h2 class="mb-3 text-h5 text-baseDark sm:text-h4">
            There is an update
          </h2>

          {/* Description */}
          <p class="mb-6 text-medium leading-relaxed text-baseDark sm:mb-8 sm:text-normal">
            We've just released a new version with improvements and bug fixes.
            Please refresh your page to get the latest updates.
          </p>

          {/* Refresh Button */}
          <button
            onClick={handleRefresh}
            class="shadow-lg hover:shadow-xl w-full rounded-2xl bg-gradient-to-r from-basePrimaryDark to-basePrimaryMedium px-6 py-3 text-mediumBold text-baseLight transition-all duration-200 hover:from-basePrimaryMedium hover:to-basePrimaryLight active:scale-95 sm:px-8 sm:py-4 sm:text-buttonMedium"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
}
